import React from 'react';
import PropTypes from 'prop-types';

import routes from 'app/routes';
import IconWithText from 'components/Widgets/IconWithText';

export default function Index({ program, wrapperClassName, children }) {
  const content = children || (
    <>
      <div className="mb-1 small fw-light text-gray-700">Coaching Program</div>

      <div className="fw-semibold">
        <a href={routes.members.programs.show(program.id)}>
          {program.title}
        </a>
      </div>
    </>
  );

  return (
    <IconWithText
      iconClassName="target-arrow-icon big-icon rounded-circle bg-gray-700"
      iconBg="bg-gray-200"
      wrapperClassName={wrapperClassName}
    >
      {content}
    </IconWithText>
  );
}

Index.propTypes = {
  program: PropTypes.object.isRequired,
  wrapperClassName: PropTypes.string,
  children: PropTypes.node,
};

Index.defaultProps = {
  wrapperClassName: '',
  children: null,
};
